export default __webpack_public_path__ + "static/media/twitter.b87566f7.png";